import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth, API } from "@/context/AuthContext";
import { resolvePostLoginPath } from "@/lib/authRedirect";
import axios from "axios";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { checkAuth } = useAuth();

  useEffect(() => {
    const code = searchParams.get("code");

    if (!code) {
      navigate("/connexion", { replace: true });
      return;
    }

    (async () => {
      try {
        const redirectUri = window.location.origin + "/auth/callback";
        const res = await axios.post(`${API}/auth/exchange`, { code, redirect_uri: redirectUri });
        localStorage.setItem("token", res.data.access_token);
        const user = await checkAuth();
        navigate(resolvePostLoginPath(user?.role), { replace: true });
      } catch {
        navigate("/connexion", { replace: true });
      }
    })();
  }, [searchParams, checkAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-lg font-medium">Connexion en cours...</div>
    </div>
  );
}
